<template>
  <v-card>
    <v-card-title class="align-center justify-center primary white--text mb-4">Historique <br/>  
      <span class="ml-2" v-if="!loading"> ({{ formattedContractSessions.length }} / {{ contractTotalStock }})</span> 
    </v-card-title>
    <v-card-text>
      <v-skeleton-loader
        v-if="loading"
        class="mx-auto"
        min-height="500"
        type="table-tbody"
      />
      <v-data-table
        v-else
        :headers="headers"
        :items="formattedContractSessions"
        :items-per-page="5"
        item-key="rowId"
        sort-by="end_time"
        sort-desc
      >
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { requests, EventBus } from '@/mixins/index';
import { format, fromUnixTime } from 'date-fns';

export default {
  mixins: [requests],
  props: {
    contract: {
      type: Object,
      default: () => {}
    },
    initialStock: {
      type: Number,
      default: 0
    },
    allContractOrders: {
      type: Array,
      default: () => []
    },
    contractHistory: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      loading: false,
      contractSessions: [],
      headers: [
        { text: 'Date et heure', value: 'date', width: '30%', align: 'center', sortable: true },
        { text: 'Séance', value: 'sessionName', width: '25%', align: 'center', sortable: false },
        { text: 'Nom du participant', value: 'fullname', width: '25%', align: 'center', sortable: false },
        { text: 'Cheval', value: 'horse', width: '20%', align: 'center', sortable: false }
      ],
      contractTotalStock: this.$props.initialStock
    };
  },
  async mounted () {
    this.loading = true;

    try {
      await this.loadContractSessions();
    } catch (error) {
      console.error('Error in ContractSessionHistory mounted:', error);
      this.loading = false;
      const notification = {
        message: 'Erreur lors de la récupération des sessions',
        type: 'danger',
        timeout: 10000
      };
      EventBus.$emit('show-notifications', [notification]);
      return;
    }

    this.calculateContractTotalStock();
    this.loading = false;
  },
  methods: {
    calculateContractTotalStock () {
      if(this.$props.contractHistory && this.$props.contractHistory.length) {
        const totalEditedStock = this.$props.contractHistory.reduce((acc, item) => acc + parseInt(item.newStock) - parseInt(item.oldStock), 0);
        this.contractTotalStock = this.contractTotalStock + totalEditedStock;
      }
    },
    async loadContractSessions () {
      if (!this.$props.contract || !this.$props.contract.contractNumber || !this.$props.contract.workspace || !this.$props.contract.validityStart || !this.$props.contract.validityEnd) {
        return;
      }
      const startDate = new Date(this.$props.contract.validityStart).getTime();
      const endDate = new Date(this.$props.contract.validityEnd).getTime();
      
      const response = await this.getContractSessions(this.$props.contract.contractNumber, this.$props.contract.workspace, startDate, endDate);

      if (!response.success) {
        throw new Error('Error in getContractSessions request!');
      }
      this.contractSessions = response.data;
    }
  },
  computed: {
    formattedContractSessions () {
      if (!this.contractSessions || !Array.isArray(this.contractSessions)) {
        return [];
      }
      
      const contractNumber = this.$props.contract.contractNumber;

      if (!contractNumber) {
        return [];
      }

      const result = [];
      
      this.contractSessions.map((session) => {
        (session.participants || []).filter(participant => parseInt(participant.contract_number) === parseInt(contractNumber))
          .map((participant) => {
            result.push({
              rowId: `${session.id}_${participant.uuid}`,
              date: `Le ${format(fromUnixTime(session.start_time), 'dd/MM/yyyy')}, de ${format(fromUnixTime(session.start_time), 'HH:mm')} à ${format(fromUnixTime(session.end_time), 'HH:mm')}`,
              sessionName: session.name,
              fullname: `${participant.firstname || ''} ${participant.lastname || ''}`.trim(),
              horse: participant.horse || '-',
              end_time: session.end_time
            });
          });
      });
      
      return result;
    }
  }
};
</script>